// extracted by mini-css-extract-plugin
export default {"limboWinInfoWin":"styles_limboWinInfoWin__ip5M4","limboWinInfoLose":"styles_limboWinInfoLose__OKCaW"};